import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function TextArea({ className, ...props }) {
  return <textarea className={clsx('form-control', className)} {...props}></textarea>
}

TextArea.propTypes = {
  className: PropTypes.string
}
